import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./App.js";
import { installTheWorker, listenToTheWorker } from "./offline.js";
import { SessionProvider } from "./session.js";
import "./i18n.js";
import "./styles.css";

// Listening comes first and unconditionally: a page opened in a basement is
// answered out of the cache by a worker installed on some earlier visit, and
// it has to be able to say so before the first read is made. Installing is
// production-only and waits for `load`, so it never competes with the first
// render for the connection it is trying to make unnecessary.
listenToTheWorker();
installTheWorker();

const root = document.getElementById("root");
if (root === null) throw new Error("No #root element in index.html.");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
